import styles from "../CategorizedNomenclatureListPage.module.scss";
import { classNames } from "primereact/utils";
import { AppDropdownMenu, IDropdownMenuItem } from "../../components/AppDropdownMenu";

interface ICategoryHeaderProps {
  name: string;
  itemCount: number;
  menuItems?: IDropdownMenuItem[];
  isDeleted?: boolean;
  emoji?: string;
  dataOnboarding?: string;
  dataOnboardingMenu?: string;
}

export const CategoryHeader = ({
  name,
  itemCount,
  menuItems,
  isDeleted = false,
  emoji,
  dataOnboarding,
  dataOnboardingMenu,
}: ICategoryHeaderProps) => {
  return (
    <div className={styles.category_header} data-onboarding={dataOnboarding}>
      <div className={styles.category_header_info}>
        {emoji && <span className={styles.category_header_emoji}>{emoji}</span>}
        <span
          className={classNames(styles.category_header_name, {
            [styles.category_header_name_deleted]: isDeleted,
          })}
        >
          {name}
        </span>
        <span className={styles.category_header_count}>({itemCount})</span>
      </div>
      {menuItems && menuItems.length > 0 && (
        <div
          className={styles.category_header_menu}
          onClick={(e) => e.stopPropagation()}
          data-onboarding={dataOnboardingMenu}
        >
          <AppDropdownMenu
            items={menuItems}
            triggerIconSize="18px"
            triggerClassName={styles.category_menu_trigger}
          />
        </div>
      )}
    </div>
  );
};
